import React, { createContext, useContext, useState, useEffect, useCallback } from "react"
import { loadPermissions, hasPermission, canView, canAdd, canEdit, canDelete, canExport, canApprove, canStatusUpdate, MODULE } from "./UserAccess"

const PermissionContext = createContext({
  loaded: false,
  hasPermission: () => true,
  canView: () => true,
  canAdd: () => true,
  canEdit: () => true,
  canDelete: () => true,
  canExport: () => true,
  canApprove: () => true,
  canStatusUpdate: () => true,
  MODULE,
  reload: () => {},
})

export const PermissionProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false)

  const load = useCallback(async () => {
    const user = localStorage.getItem("authUser")
    if (!user) { setLoaded(true); return }
    console.time("⏱️ Permissions Load")
    await loadPermissions()
    console.timeEnd("⏱️ Permissions Load")
    setLoaded(true)
  }, [])

  useEffect(() => { load() }, [load])

  const value = {
    loaded,
    hasPermission,
    canView, canAdd, canEdit, canDelete, canExport, canApprove, canStatusUpdate,
    MODULE,
    reload: load,
  }

  return (
    <PermissionContext.Provider value={value}>
      {children}
    </PermissionContext.Provider>
  )
}

/**
 * Hook to access permissions anywhere in the component tree.
 * Usage:
 *   const { canView, canAdd, MODULE } = usePermissions()
 *   if (canView(MODULE.PRODUCERS)) { ... }
 */
export const usePermissions = () => useContext(PermissionContext)

export default PermissionContext
